

export function openUrl(url: string) {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel="noreferrer"
    document.body.appendChild(link);
    link.click();
    link.remove();
}

export async function downloadFile(url: string, filename: string, type = 'mp4') {
    const response = await fetch(url);
    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.target = '_blank';
    link.rel="noreferrer"
    link.download = `${filename}.${type}`;
    link.click();
    document.body.appendChild(link);
    link.remove();
}